/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
 */
export default {
  state: {
    appId: null,
    appList: []
  },
  mutations: {
    setAppId(state, v) {
      return (state.appId = v);
    },
    changeApp(state, v) {
      return (state.appId = v);
    },
    setAppList(state, v) {
      return (state.appList = v);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/app.js